<script setup>
const emit = defineEmits(['redirectToLogin'])
const {
  hasCustomerId,
} = useSessionData()
const { t } = useI18n()
</script>

<template>
  <div class="flex grow flex-col justify-between flex-gap-y-4 whitespace-pre-wrap p-8">
    <template v-if="hasCustomerId">
      <h4 class="text-center text-lg text-text-600 font-500">
        {{ t('This event does not exist or you cannot access it') }}
      </h4>
    </template>
    <template v-else>
      <h4 class="text-center text-lg text-text-600 font-500">
        {{ t('Please log in to see event details') }}
      </h4>
      <div
        class="flex flex-col items-center flex-gap-y-2"
      >
        <DSButton
          class="btn btn-md w-full uppercase btn-fill-primary"
          @click="emit('redirectToLogin')"
        >
          <span>{{ t('Login') }}</span>
        </DSButton>
      </div>
    </template>
  </div>
</template>

<i18n>
{
  "en-us": {
    "This event does not exist or you cannot access it": "This event does not exist or you cannot access it",
    "Please log in to see event details": "Please log in to see event details",
    "Login": "Login"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "This event does not exist or you cannot access it": "Dieses Ereignis existiert nicht oder Sie können nicht darauf zugreifen",
  "Please log in to see event details": "Bitte melde dich an, um die Details für die Veranstaltung zu sehen",
  "Login": "Anmelden"
}
</i18n>

  <i18n locale="es" lang="json">
{
  "This event does not exist or you cannot access it": "Este evento no existe o no puedes acceder a él",
  "Please log in to see event details": "Inicia sesión para ver los detalles del evento",
  "Login": "Iniciar sesión"
}
</i18n>

  <i18n locale="fr" lang="json">
{
  "This event does not exist or you cannot access it": "Cet événement n'existe pas ou vous n'y avez pas accès",
  "Please log in to see event details": "Veuillez vous connecter pour voir les détails de l'événement",
  "Login": "Se connecter"
}
</i18n>
